import React, { useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAdminNoticeAdd = () => {
  const [loading, setLoading] = useState(true);
  const [csrf, setCsrf] = useState('');
  const [error, setError] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [sortOrder, setSortOrder] = useState(0);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await axios.get('/api/platform_admin/notices/add', {
        withCredentials: true,
      });

      if (res.data && res.data.ok) {
        setCsrf(res.data.csrf || '');
        setError(res.data.error || '');
      } else if (res.data && res.data.redirect) {
        window.location.href = res.data.redirect;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      console.error('공지 등록 화면 로드 실패:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async (e) => {
    e.preventDefault();

    try {
      const res = await axios.get('/api/platform_admin/logout', {
        withCredentials: true,
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }

      window.location.href = '/platform_admin/login';
    } catch (err) {
      console.error('로그아웃 실패:', err);
      window.location.href = '/platform_admin/login';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new URLSearchParams();
      formData.append('csrf_token', csrf);
      formData.append('title', title);
      formData.append('content', content);
      if (isActive) {
        formData.append('is_active', 'on');
      }
      formData.append('sort_order', String(sortOrder));

      const res = await axios.post('/api/platform_admin/notices/add', formData, {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (res.data && res.data.ok && res.data.redirect) {
        window.location.href = res.data.redirect;
        return;
      }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        const redirectUrl =
          err.response.data && err.response.data.redirect
            ? err.response.data.redirect
            : '/platform_admin/login';
        window.location.href = redirectUrl;
        return;
      }

      if (err.response && err.response.data) {
        setError(err.response.data.error || err.response.data.msg || '오류가 발생했습니다.');
        if (err.response.data.csrf) setCsrf(err.response.data.csrf);
        return;
      }

      console.error('공지 등록 실패:', err);
      setError('오류가 발생했습니다.');
    }
  };

  return (
    <div className="bg-light min-vh-100">
      <nav className="navbar navbar-dark bg-dark px-4">
        <span className="navbar-brand">플랫폼 관리자</span>
        <div>
          <a href="/platform_admin/sellers" className="btn btn-sm btn-outline-light me-2">
            셀러관리
          </a>
          <a href="/platform_admin/shops" className="btn btn-sm btn-outline-light me-2">
            상점관리
          </a>
          <a href="/platform_admin/orders" className="btn btn-sm btn-outline-light me-2">
            주문관리
          </a>
          <a href="/platform_admin/claims" className="btn btn-sm btn-outline-light me-2">
            클레임
          </a>
          <a href="/platform_admin/notices" className="btn btn-sm btn-outline-light active me-2">
            공지관리
          </a>
          <a href="/platform_admin/logout" onClick={handleLogout} className="btn btn-sm btn-danger">
            로그아웃
          </a>
        </div>
      </nav>

      <div className="container my-4" style={{ maxWidth: '900px' }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">📢 공지 등록</h4>
          <a href="/platform_admin/notices" className="btn btn-outline-dark btn-sm">
            목록
          </a>
        </div>

        {error ? <div className="alert alert-danger py-2">{error}</div> : null}

        <div className="card shadow-sm">
          <div className="card-body">
            {loading ? (
              <div className="text-center py-4 text-muted">불러오는 중...</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <input type="hidden" name="csrf_token" value={csrf} />

                <div className="mb-3">
                  <label className="form-label fw-semibold">제목</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    maxLength="200"
                    required
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label fw-semibold">내용</label>
                  <textarea
                    name="content"
                    className="form-control"
                    rows="10"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                  />
                </div>

                <div className="d-flex gap-4 align-items-center mb-3 flex-wrap">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_active"
                      name="is_active"
                      checked={isActive}
                      onChange={(e) => setIsActive(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="is_active">
                      노출
                    </label>
                  </div>

                  <div className="d-flex align-items-center gap-2">
                    <label className="form-label mb-0 fw-semibold">정렬</label>
                    <input
                      type="number"
                      name="sort_order"
                      className="form-control"
                      value={sortOrder}
                      onChange={(e) => setSortOrder(e.target.value)}
                      style={{ width: '120px' }}
                    />
                    <span className="text-muted small">높을수록 상단</span>
                  </div>
                </div>

                <button type="submit" className="btn btn-dark">
                  등록
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformAdminNoticeAdd;